import { render, staticRenderFns } from "./SettingsPanel.vue?vue&type=template&id=169ae052&"
import script from "./SettingsPanel.vue?vue&type=script&lang=js&"
export * from "./SettingsPanel.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports